module.exports = __webpack_public_path__ + "public/img/banner-text.f9585c90.png";